module.exports = __webpack_public_path__ + "static/media/bb.ae5748d7.webp";